import { c as _c } from "react/compiler-runtime";
import { Tooltip as ChakraTooltip, Portal } from '@chakra-ui/react';
import * as React from 'react';
export interface TooltipProps extends ChakraTooltip.RootProps {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement | null>;
  content: React.ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  disabled?: boolean;
}
export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
  const $ = _c(26);
  let children;
  let content;
  let contentProps;
  let disabled;
  let portalRef;
  let rest;
  let showArrow;
  let t0;
  if ($[0] !== props) {
    ({
      showArrow,
      children,
      disabled,
      portalled: t0,
      content,
      contentProps,
      portalRef,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = content;
    $[3] = contentProps;
    $[4] = disabled;
    $[5] = portalRef;
    $[6] = rest;
    $[7] = showArrow;
    $[8] = t0;
  } else {
    children = $[1];
    content = $[2];
    contentProps = $[3];
    disabled = $[4];
    portalRef = $[5];
    rest = $[6];
    showArrow = $[7];
    t0 = $[8];
  }
  const portalled = t0 === undefined ? true : t0;
  if (disabled) {
    return children;
  }
  let t1;
  if ($[9] !== children) {
    t1 = <ChakraTooltip.Trigger asChild={true}>{children}</ChakraTooltip.Trigger>;
    $[9] = children;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const t2 = !portalled;
  let t3;
  if ($[11] !== showArrow) {
    t3 = showArrow && <ChakraTooltip.Arrow><ChakraTooltip.ArrowTip /></ChakraTooltip.Arrow>;
    $[11] = showArrow;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== content || $[14] !== contentProps || $[15] !== ref || $[16] !== t3) {
    t4 = <ChakraTooltip.Positioner><ChakraTooltip.Content ref={ref} {...contentProps}>{t3}{content}</ChakraTooltip.Content></ChakraTooltip.Positioner>;
    $[13] = content;
    $[14] = contentProps;
    $[15] = ref;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== portalRef || $[19] !== t2 || $[20] !== t4) {
    t5 = <Portal container={portalRef} disabled={t2}>{t4}</Portal>;
    $[18] = portalRef;
    $[19] = t2;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== rest || $[23] !== t1 || $[24] !== t5) {
    t6 = <ChakraTooltip.Root {...rest}>{t1}{t5}</ChakraTooltip.Root>;
    $[22] = rest;
    $[23] = t1;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
});